export default function humanize(value) {
  if (!value) {
    return '';
  }

  // Handle acronyms
  if (value.toUpperCase() === value) {
    return value;
  }

  return value.charAt(0).toUpperCase() + value.substr(1).replace(/[A-Z]|\d+/g, ' $&');
}
